/**
 * Created by jimmy on 2019/11/8.
 */

const host = window.location.host;
export const env = (host.indexOf('127.0.0.1') > -1 || host.indexOf('localhost') > -1) ? 'env' : 'product';

// export const apiPrefix = 'http://api.yeekin.cn/v1';
export const apiPrefix = '/api/v1';
export const uploadPrefix = '/api/v1';
export const imgPrefix = env == 'product' ? `https://${window.location.host}/` : 'http://127.0.0.1:33003/';
export const imgUrl = 'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/';
export const videoPrefix = `/`;

export const appName = '朱家角旅游';

export const pageLimit = 30;

export const yesnoMap = {
  1: '是',
  2: '否'
};

export const mallStatus = { 1: '初始化中', 2: '运行中', 3: '已过期', 4: '异常' };

//公告类型
export const mallType = { 1: '外链', 2: '本站文章' };
export const announceType = { 1: '外链', 2: '本站文章' };
export const types = { 1: '特色景点', 2: '文保点位',3:'历史古桥',4:'人文建筑' };
export const guiderType = { 1: '中文', 2: '英文', 3: '日文', 4: '德文', 5: '韩文' };
export const transType = { 1: '机场线路', 2: '自驾线路', 3: '公交线路'};
export const introType = { 1: '上架', 2: '下架' };
export const menuType = { 1: '电子地图', 2: '实时信息', 3: '导游服务', 4: '旅游交通',5: '咨询公告',6:'门票购买',7:'游船信息',8:'景点介绍',9:'古镇精选',10:'精彩视频',11:'投诉建议',12:'官方网站',13:'争创5A' };

// 商家主体类型
export const businessCategoryTypeMap = { 1: '企业', 2: '个体户', 3: '个人', 4: '其他' };
